import { Edit2, FilterRemove, Trash } from "iconsax-react";
import React, { useState } from "react";
import FilterTextInput from "../FilterTextInput";
import { motion as m } from "framer-motion";
import Can from "../Can";
import { useNavigate } from "react-router-dom";
import Paginator from "../Paginator";
import { USER_EDIT } from "../../Router/path";
import { useToast } from "../Toast";
import axios from "axios";
import { DELETE_USER_API } from "../../Constant/api";
import Modal from "../Modal";

const UserListTable = ({
  data,
  meta,
  handlePageClick,
  searchTerm,
  handleSearch,
  handleKeyDown,
  perPage,
  handlePerPageChange,
  clearFilter,
}) => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const toggleModal = (userId = null) => {
    setSelectedUserId(userId);
    setShowModal(!showModal);
  };

  const handleDelete = () => {
    if (!selectedUserId) return;
    try {
      axios
        .delete(DELETE_USER_API, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
          params: { id: selectedUserId },
        })
        .then((res) => {
          toast("User deleted successfully.", "success");
          setShowModal(false);
          handlePageClick(meta.page);
        })
        .catch((err) => {
          console.log(err);
          toast("Failed to delete user.", "error");
        });
    } catch (err) {
      console.log(err);
      toast("Failed to delete user.", "error");
    }
  };

  return (
    <m.div
      className="flex flex-col border border-[#EFF0F2] w-full h-fit bg-white rounded-xl"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {showModal && (
        <Modal toggleModal={() => toggleModal()} confirmation={handleDelete}>
          <div className="flex flex-col w-full items-center justify-center gap-[16px] py-[32px]">
            <Trash size="64" color="#ff0000" variant="Bold" />
            <p>Are you sure you want to delete this user?</p>
          </div>
        </Modal>
      )}

      <div className="flex flex-col w-full h-full">
        {/* Filters */}
        <div className="flex w-full border-b border-[#EFF0F2] px-[24px] py-[12px] gap-[8px] items-center justify-end">
          {clearFilter && searchTerm !== "" && (
            <FilterRemove
              size="16"
              onClick={clearFilter}
              variant="Bold"
              className="text-[#FF3030] hover:cursor-pointer hover:text-[#5C4BF5]"
            />
          )}
          <FilterTextInput
            value={searchTerm}
            onChange={(e) => handleSearch(e)}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="flex w-full h-full gap-[24px] no-scrollbar overflow-x-auto">
          {!data || data.length === 0 ? (
            <div className="flex w-full h-[290px] items-center border-[#EFF0F2] justify-center text-gray-500 text-[25px]">
              No users found
            </div>
          ) : (
            <table className="w-full h-full">
              {/* Table Header */}
              <tr className="w-full bg-[#F7F8F9]">
                <th className="text-start px-[24px] py-[16px]">Name</th>
                <th className="text-start px-[24px] py-[16px]">Email</th>
                <th className="text-start px-[24px] py-[16px]">Event</th>
                <th className="text-start px-[24px] py-[16px]">Role</th>
                <th className="text-start px-[24px] py-[16px]"></th>
              </tr>

              {/* Table Body */}
              {data &&
                data.map((item) => (
                  <tr
                    key={item.id}
                    className="w-full font-normal border-b border-[#EFF0F2] last:border-none"
                  >
                    <td className="px-[24px] py-[16px]">{item.name ?? "-"}</td>
                    <td className="px-[24px] py-[16px]">{item.email ?? "-"}</td>
                    <td className="px-[24px] py-[16px]">
                      {item.event?.name ?? "-"}
                    </td>
                    <td className="px-[24px] py-[16px]">
                      {item.role?.name ?? "-"}
                    </td>
                    <td className="flex px-[24px] py-[16px] h-full gap-[12px] items-center justify-end">
                      <Can permission="edit_user">
                        <span
                          className="flex text-[#5C4BF5] text-[14px] items-center hover:underline cursor-pointer"
                          onClick={() =>
                            navigate(USER_EDIT, { state: item.id })
                          }
                        >
                          <Edit2 size="15" variant="Bold" />
                          Edit
                        </span>
                      </Can>
                      <Can permission="delete_user">
                        <span
                          className="flex text-red-500 text-[14px] items-center hover:underline cursor-pointer"
                          onClick={() => toggleModal(item.id)}
                        >
                          <Trash size="15" variant="Bold" />
                          Delete
                        </span>
                      </Can>
                    </td>
                  </tr>
                ))}
            </table>
          )}
        </div>
      </div>

      {/* Pagination */}
      {meta && (
        <Paginator
          meta={meta}
          perPage={perPage}
          handlePerPageChange={handlePerPageChange}
          handlePageClick={handlePageClick}
        />
      )}
    </m.div>
  );
};

export default UserListTable;
